
import { Pie } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
} from 'chart.js';
// FIX 1: Importar el plugin que faltaba
import ChartDataLabels from 'chartjs-plugin-datalabels';

// FIX 4: Mover la función fuera del componente para mejor rendimiento.
/**
 * Genera una lista de colores HSL vibrantes y distintos.
 * @param {number} count La cantidad de colores a generar.
 * @returns {{backgrounds: string[], borders: string[]}} Un objeto con arrays para fondos y bordes.
 */
function generateVibrantColors(count) {
  const colors = {
    backgrounds: [],
    borders: [],
  };
  const saturation = 80;
  const lightness = 60;
  
  for (let i = 0; i < count; i++) {
    const hue = (i * 360) / count;
    colors.backgrounds.push(`hsla(${hue}, ${saturation}%, ${lightness}%, 0.7)`);
    colors.borders.push(`hsla(${hue}, ${saturation}%, ${lightness}%, 1)`);
  }
  return colors;
}

// FIX 1 (continuación): Registrar el plugin junto a los otros elementos.
ChartJS.register(ArcElement, Tooltip, Legend, ChartDataLabels);

const CountryPieChart = ({ title, labels, dataValues }) => {

  const chartColors = generateVibrantColors(labels.length);

  const data = {
    labels: labels,
    datasets: [
      {
        label:title,
        data: dataValues,
        backgroundColor: chartColors.backgrounds,
        borderColor: chartColors.borders,
        borderWidth: 1,
        // FIX 2: La propiedad 'cutout' va directamente en el dataset.
        cutout: '50%', 
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false, 
    plugins: {
      legend: {
        position: 'right',
        display: true, // Correcto, desactivamos la leyenda original
      },
      // Esta configuración ahora sí será leída por Chart.js
      datalabels: {
        color: '#FFF', // Cambiado a blanco para mejor contraste sobre fondos oscuros
        anchor: 'end',
        align: 'start',
        offset: -20, // Ajusta la posición para que quede dentro de la rebanada
        textStrokeColor: '#333',
        textStrokeWidth: 2,
        font: {
          weight: 'bold',
          size: 12,
        },
        // Formatea lo que muestra la etiqueta
        formatter: (value, context) => {
          // Ocultar etiqueta si la rebanada es muy pequeña (ej. < 3%)
          const total = context.chart.data.datasets[0].data.reduce((sum, val) => sum + val, 0);
          if ((value / total) < 0.03) {
            return null;
          }
          
          const label = context.chart.data.labels[context.dataIndex];
          const percentage = (value / total * 100).toFixed(1) + '%';
          
          // FIX 3: Usar backticks (`) para la interpolación de cadenas.
          return `${label}\n${percentage}`; 
        }
      }
    }
  };

  // Añadimos un div contenedor para darle un tamaño al gráfico
  return (
    <div style={{ position: 'relative', height: '200px', width: '100%' }}>
       <Pie data={data} options={options} />
    </div>
  );
};

export default CountryPieChart;